import * as React from 'react';
import { SVGProps } from 'react';

export const OpenSVG = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}>
        <path
            d="M10 9.99967L16.6667 3.33301M16.6667 3.33301H11.6667M16.6667 3.33301V8.33301"
            stroke="#637488"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16.6663 11.6663V14.9997C16.6663 15.9201 15.9201 16.6663 14.9997 16.6663H4.99967C4.0792 16.6663 3.33301 15.9201 3.33301 14.9997V4.99967C3.33301 4.0792 4.0792 3.33301 4.99967 3.33301H8.33301"
            stroke="#637488"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
